<div class="flex flex-col items-center h-[70%] justify-center gap-10 text-center">
    <i class="pi pi-times-circle text-[130px] text-red-500"></i>
    <span class="text-app-primary-1 font-extrabold text-[60px]">{{ 'access_denied' | translate }}</span>
    <div class="flex flex-col gap-5 text-lg">
       <span>{{ 'no_permission_to_view_this_page' | translate }}</span>
       <span>{{ 'please_contact_your_admin' | translate }}</span>
    </div>
    <div class="flex gap-2">
       <span class="text-sm font-extrabold">{{ 'error' | translate }}:</span>
       <span class="text-sm">{{ 'missing_licence_for_this_tool' | translate }}</span>
    </div>
 
    <p-button
       class="mt-[10px]"
       styleClass="basic-primary-1-button px-[25px] py-[10px] font-semibold hover:py-[7px] hover:px-[23px]"
       (onClick)="authService.logout()"
    >
       <span>{{ 'logout' | translate }}</span>
    </p-button>
 </div>